(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  // Hide the carousel arrows when the scroll area doesn't actually overflow
  // (e.g. desktop shows 4 columns and exactly 4 products came back — nothing to
  // scroll to). The theme's carousel also does this, but it can measure before
  // the AJAX-injected content / images settle, so we re-check here.
  var syncRelatedArrows = function (root) {
    root = root || document.querySelector('.related-products');
    if (!root) return;
    var scroll = root.querySelector('.cc-carousel__scroll-area');
    if (!scroll) return;

    // Deterministic rule: if the number of product cards is <= the columns
    // shown for the current breakpoint, they all fit in one row → nothing to
    // scroll → hide the arrows. This avoids false positives from sub-pixel
    // gap/margin overflow that pixel-only checks (and the theme) trip on.
    var count = scroll.children.length;
    var perRowDesktop = parseInt(root.getAttribute('data-per-row-desktop') || '4', 10);
    var perRowMobile = parseInt(root.getAttribute('data-per-row-mobile') || '2', 10);
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var perRow = isMobile ? perRowMobile : perRowDesktop;

    var fitsByCount = count <= perRow;
    // Secondary guard: also treat "less than a quarter of an item overflowing"
    // as no-scroll, so a stray few pixels never forces the arrows on.
    var itemW = scroll.firstElementChild ? scroll.firstElementChild.getBoundingClientRect().width : 0;
    var overflow = scroll.scrollWidth - scroll.clientWidth;
    var fitsByPixels = itemW > 0 ? overflow <= itemW * 0.25 : overflow <= 2;

    root.classList.toggle('related-products--no-nav', fitsByCount || fitsByPixels);
  };

  var loadRelatedProductsIntoSection = function () {
    // Look for an element with class 'related-products'
    var relatedProductsSection = document.querySelector('.related-products');
    if (relatedProductsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', relatedProductsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
        theme.initAnimateOnScroll();

        // Re-check overflow now, on the next frame, and once each image loads
        // (image loading can shift layout and change whether it overflows).
        syncRelatedArrows(relatedProductsSection);
        requestAnimationFrame(function () { syncRelatedArrows(relatedProductsSection); });
        relatedProductsSection.querySelectorAll('img').forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', function () { syncRelatedArrows(relatedProductsSection); }, { once: true });
        });
      }
    };
    request.send();
  };
  // Fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadRelatedProductsIntoSection();
    }
  });
  // Fetch the products on page load
  loadRelatedProductsIntoSection();

  // Viewport width changes how many columns fit — re-check on resize.
  var relatedArrowsResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(relatedArrowsResizeTimer);
    relatedArrowsResizeTimer = setTimeout(function () { syncRelatedArrows(); }, 200);
  });
  // Late-loading fonts/images can change layout after full load.
  window.addEventListener('load', function () { syncRelatedArrows(); });

  } catch(e) { console.error(e); }
})();
})();
